// extracted by mini-css-extract-plugin
export var bounce = "_l3-1";
export var generatingText = "_l3-6";
export var lightning = "_l3-4";
export var popup = "_l3-5";
export var progressBar = "_l3-7";
export var progressFill = "_l3-8";
export var progressShimmer = "_l3-9";
export var progressText = "_l3-a";
export var shimmer = "_l3-3";
export var uploadIcon = "_l3-0";
export var uploadingText = "_l3-2";